var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.9 19.6923L0 24V1.23077C0 0.55104 0.492492 0 1.1 0H20.9C21.5075 0 22 0.55104 22 1.23077V18.4615C22 19.1413 21.5075 19.6923 20.9 19.6923H4.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.8806 9.99947L15.8153 6.07065C15.9329 5.95303 15.9989 5.79351 15.9989 5.62717C15.9989 5.46083 15.9329 5.30131 15.8153 5.18369C15.6977 5.06608 15.5381 5 15.3718 5C15.2055 5 15.046 5.06608 14.9284 5.18369L11 9.11876L7.0716 5.18369C6.95399 5.06608 6.79449 5 6.62817 5C6.46185 5 6.30234 5.06608 6.18474 5.18369C6.06714 5.30131 6.00107 5.46083 6.00107 5.62717C6.00107 5.79351 6.06714 5.95303 6.18474 6.07065L10.1194 9.99947L6.18474 13.9283C6.1262 13.9864 6.07974 14.0554 6.04803 14.1316C6.01632 14.2077 6 14.2893 6 14.3718C6 14.4542 6.01632 14.5359 6.04803 14.612C6.07974 14.6881 6.1262 14.7572 6.18474 14.8152C6.2428 14.8738 6.31188 14.9203 6.38798 14.952C6.46409 14.9837 6.54572 15 6.62817 15C6.71062 15 6.79225 14.9837 6.86836 14.952C6.94446 14.9203 7.01354 14.8738 7.0716 14.8152L11 10.8802L14.9284 14.8152C14.9865 14.8738 15.0555 14.9203 15.1316 14.952C15.2078 14.9837 15.2894 15 15.3718 15C15.4543 15 15.5359 14.9837 15.612 14.952C15.6881 14.9203 15.7572 14.8738 15.8153 14.8152C15.8738 14.7572 15.9203 14.6881 15.952 14.612C15.9837 14.5359 16 14.4542 16 14.3718C16 14.2893 15.9837 14.2077 15.952 14.1316C15.9203 14.0554 15.8738 13.9864 15.8153 13.9283L11.8806 9.99947Z",
    fill: "#FF0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseChat);
export default __webpack_public_path__ + "static/media/CloseChat.c51e6b92bb985cc8811e182d475a9b19.svg";
export { ForwardRef as ReactComponent };